/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect, useState } from 'react';
import avatar from 'src/assets/img_avatar.png';
import editIcon from 'src/assets/edit_profile.svg';
import { useTypedSelector } from 'src/hooks/useTypedSelector';
import uploadProfilePictureService from 'src/services/upload-profile-picture.service';
import { useTranslation } from 'react-i18next';
import { AlertAdapter, Loader } from 'pg-ui-library';
import {
  EditIcon,
  EditIconContainer,
  EmployeeAvatar,
  EmployeeAvatarLoadingDiv,
  HiddenInput,
  ImgContainer,
} from './styles';

const ProfilePicture: React.FC<{ editing: boolean }> = ({ editing = false }) => {
  const { data, loading: personalInfoLoading } = useTypedSelector(state => state.personalInfo);
  const [loading, setLoading] = useState(false);
  const inputRef = React.useRef<HTMLInputElement>(null);
  const imgRef = React.useRef<HTMLImageElement>(null);
  const { t } = useTranslation();

  const onImgClick = async () => {
    if (!editing) return;
    inputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      fileUploadHandler(event.target.files[0]);
    }
  };

  const fileUploadHandler = async (file: File) => {
    if (!validFileFormat(file)) return;
    if (file) {
      const fd = new FormData();
      fd.append('picture', file, file.name || '');
      setLoading(true);
      uploadProfilePictureService
        .upload(fd, data.personalInfo?.id || '')
        .then(
          () => {
            onFileUploadSuccess(file);
          },
          () => {
            if (imgRef.current) {
              imgRef.current.src = data.personalInfo?.profileUrl || avatar;
            }
          }
        )
        .finally(() => setLoading(false));
    }
  };

  const onFileUploadSuccess = async (file: File) => {
    const reader = new FileReader();
    reader.onload = e => {
      if (imgRef.current) {
        imgRef.current.src = e.target?.result?.toString() || avatar;
      }
    };
    reader.readAsDataURL(file);
  };

  const imgFallback = (ev: any) => {
    ev.target.src = avatar;
  };

  const validFileFormat = (file: File): boolean => {
    const valid = ['image/jpeg', 'image/jpg', 'image/png'];
    if (formatSize(file.size) > 5) {
      AlertAdapter(t('personalInfo.profilePicture.invalidFileSize'), 'warning');
      return false;
    }
    if (!valid.includes(file.type)) {
      AlertAdapter(t('personalInfo.profilePicture.invalidFileFormat'), 'warning');
      return false;
    }
    return true;
  };

  const formatSize = (size: number) => {
    const fileSize = size / 1024 / 1024; // in MiB
    return fileSize;
  };

  useEffect(() => {}, [data.personalInfo?.profileUrl]);

  return (
    <>
      <HiddenInput type="file" onChange={handleFileChange} accept="image/*" ref={inputRef} />
      <ImgContainer onClick={onImgClick}>
        {personalInfoLoading || loading ? (
          <EmployeeAvatarLoadingDiv>
            <Loader />
          </EmployeeAvatarLoadingDiv>
        ) : (
          <EmployeeAvatar src={data.personalInfo?.profileUrl || avatar} onError={imgFallback} ref={imgRef} />
        )}

        {editing && (
          <EditIconContainer>
            <EditIcon src={editIcon} />
          </EditIconContainer>
        )}
      </ImgContainer>
    </>
  );
};

export default ProfilePicture;
